// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2krPE","rootSuccess":"CompleteLink_rootSuccess__3wJvw","rootFailure":"CompleteLink_rootFailure__1cqgQ","isDisabled":"CompleteLink_isDisabled__2MMkA"};